/**
 * Space out colors in array while keeping first and last one
 * and having a maximum length of `maxLength`
 *
 * @param {string[]} colors array containing colors
 * @param {number} maxLength maximum number of colors to return, defaults to 8
 * @returns {string[]} returns an array of at most `maxLength` colors spaced out
 */
export function spaceOutColorsForDisplay(colors: string[], maxLength = 8): string[] {
  const len = colors.length;
  const spacedOutColors = [];
  if (len) {
    const middleCount = Math.max(maxLength - 2, 0);
    if (middleCount === 0) {
      return len > 1 ? [colors[0], colors[len - 1]] : [colors[0]];
    }

    const step = Math.max(Math.floor((len - 2) / middleCount), 1);
    spacedOutColors.push(colors[0]);

    let count = 0;
    for (let i = 1; i < len - 1; i += step) {
      if (count >= middleCount) {
        break;
      }
      spacedOutColors.push(colors[i]);
      count++;
    }
    spacedOutColors.push(colors[len - 1]);
  }

  return spacedOutColors;
}
